import type { CustomIconProps } from '../types';

const Photo = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 24 24"
        width={width ?? '24'}
        height={height ?? '24'}
    >
        <path d="M23.07 4.54a2.2 2.2 0 00-1.63-.71h-3.75l-2.16-2.28H8.47L6.31 3.83H2.56a2.2 2.2 0 00-1.63.71 2.27 2.27 0 00-.69 1.64v13.93a2.27 2.27 0 00.69 1.63 2.2 2.2 0 001.63.71h18.88a2.2 2.2 0 001.63-.71 2.27 2.27 0 00.69-1.63V6.18a2.27 2.27 0 00-.69-1.64zm-1.27 14a1.82 1.82 0 01-.57 1.33 1.86 1.86 0 01-1.36.57H4.13a1.86 1.86 0 01-1.36-.57 1.82 1.82 0 01-.57-1.33v-11a1.82 1.82 0 01.57-1.33 1.86 1.86 0 011.36-.57h3.13l1.8-2.13h5.89l1.79 2.13h3.13a1.86 1.86 0 011.36.57 1.82 1.82 0 01.57 1.33z" />
        <path d="M16.17 8.51A5.69 5.69 0 0012 6.77a5.69 5.69 0 00-4.17 1.74 5.69 5.69 0 00-1.74 4.17 5.69 5.69 0 001.74 4.17A5.69 5.69 0 0012 18.59a5.69 5.69 0 004.17-1.74 5.69 5.69 0 001.74-4.17 5.69 5.69 0 00-1.74-4.17zm-1.52 6.79a3.73 3.73 0 01-5.3 0 3.73 3.73 0 010-5.3 3.73 3.73 0 015.3 0 3.73 3.73 0 010 5.3z" />
    </svg>
);

export default Photo;
